import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import WhyHost from './components/WhyHost';
import ExperienceTiers from './components/ExperienceTiers';
import ArtisticDirectors from './components/ArtisticDirectors';
import ArtisticStandard from './components/ArtisticStandard';
import ServiceAreas from './components/ServiceAreas';
import Booking from './components/Booking';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#organization`,
        "name": "The Salon Society",
        "description": "Curated private classical concerts and chamber music performances in Nashville, Brentwood, and Franklin homes",
        "url": import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com',
        "logo": {
          "@type": "ImageObject",
          "url": "https://public.readdy.ai/ai/img_res/5a784f7f-0b3e-4f40-a8cc-c4e334701369.png",
          "width": 400,
          "height": 400
        },
        "image": {
          "@type": "ImageObject",
          "url": "https://public.readdy.ai/ai/img_res/5a784f7f-0b3e-4f40-a8cc-c4e334701369.png",
          "width": 1200,
          "height": 630
        },
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Nashville",
          "addressRegion": "TN",
          "addressCountry": "US",
          "postalCode": "37205"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 36.1627,
          "longitude": -86.7816
        },
        "telephone": "+1-615-555-0123",
        "email": "info@thesalonsociety.com",
        "foundingDate": "2020",
        "areaServed": [
          {
            "@type": "City",
            "name": "Nashville",
            "addressRegion": "TN",
            "addressCountry": "US"
          },
          {
            "@type": "City", 
            "name": "Brentwood",
            "addressRegion": "TN",
            "addressCountry": "US"
          },
          {
            "@type": "City",
            "name": "Franklin",
            "addressRegion": "TN",
            "addressCountry": "US"
          },
          {
            "@type": "City",
            "name": "Green Hills",
            "addressRegion": "TN",
            "addressCountry": "US"
          }
        ],
        "serviceType": ["Private Classical Concerts", "Chamber Music Performances", "Home Entertainment", "Cultural Events"],
        "sameAs": [
          "https://facebook.com/thesalonsociety",
          "https://instagram.com/thesalonsociety",
          "https://twitter.com/thesalonsociety"
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#website`,
        "url": import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com',
        "name": "The Salon Society",
        "description": "Private classical concerts in your Nashville home. World-class chamber music performances for discerning hosts.",
        "publisher": {
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#organization`
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}/?s={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#webpage`,
        "url": import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com',
        "name": "Nashville Private Classical Concerts | The Salon Society",
        "isPartOf": {
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#website`
        },
        "about": {
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#organization`
        },
        "description": "The Salon Society presents curated classical concerts in your Nashville, Brentwood, Franklin, or Green Hills home. World-class chamber music performances for discerning hosts.",
        "breadcrumb": {
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#breadcrumb`
        },
        "datePublished": "2020-01-01",
        "dateModified": "2024-12-19"
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#breadcrumb`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'
          }
        ]
      },
      {
        "@type": "Service",
        "name": "Private Classical Concert Experience",
        "provider": {
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://thesalonsociety.com'}#organization`
        },
        "description": "Intimate chamber music performances in private homes featuring world-class musicians from elite conservatories",
        "areaServed": [
          "Nashville, TN",
          "Brentwood, TN", 
          "Franklin, TN",
          "Green Hills, TN"
        ],
        "serviceType": "Entertainment Service",
        "category": "Cultural Events",
        "audience": {
          "@type": "Audience",
          "audienceType": "Private Event Hosts"
        },
        "offers": [
          {
            "@type": "Offer",
            "name": "Intimate Experience",
            "description": "Solo or duo performances for intimate gatherings",
            "price": "3500",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          },
          {
            "@type": "Offer", 
            "name": "Signature Experience",
            "description": "Chamber ensemble performances for sophisticated entertaining",
            "price": "6500",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          },
          {
            "@type": "Offer",
            "name": "Grand Experience", 
            "description": "Full ensemble performances for prestigious events",
            "price": "12000",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What areas do you serve for private classical concerts?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The Salon Society serves Nashville, Brentwood, Franklin, Green Hills, and surrounding Middle Tennessee areas for private classical concert experiences."
            }
          },
          {
            "@type": "Question",
            "name": "What is included in a private salon concert?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Each salon concert includes world-class musicians, curated classical repertoire, pre-concert consultation, and a refined intimate performance experience in your home."
            }
          },
          {
            "@type": "Question",
            "name": "How much do private classical concerts cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our experiences start at $3,500 for intimate solo/duo performances, $6,500 for signature chamber ensembles, and $12,000 for grand full ensemble experiences."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead 
        schemaData={schemaData}
      />
      <main>
        <Hero />
        <Philosophy />
        <WhyHost />
        <ExperienceTiers />
        <ArtisticDirectors />
        <ArtisticStandard />
        <ServiceAreas />
        <Booking />
        <Footer />
      </main>
    </>
  );
}